import React from "react";
import UploadButton from "Components/Pages/UploadButton/UploadButton";
import { UploadGrossEarningsResponse } from "Shared/types/GrossEarnings";
import { useMutation } from "@apollo/client";
import mutations from "Shared/mutations";
import queries from "Shared/queries";
import { GrossEarningsIcon } from "Components/Icons";
import CalloutCard, { CalloutCardProps } from "../CalloutCard/CalloutCard";
import InternalRoutes from "Shared/Constants/InternalRoutes";
import useStyles from "../styles";

const GrossEarningsCalloutCard = () => {
  const classes = useStyles();
  const [uploadGrossEarningsFile] = useMutation<UploadGrossEarningsResponse>(
    mutations.UPLOAD_GROSS_EARNINGS_FILE
  );
  const refetchQueries = [
    {
      query: queries.GET_GROSS_EARNINGS_TRANSMISSIONS_FILES_QUERY,
    },
  ];

  const props: CalloutCardProps = {
    icon: <GrossEarningsIcon />,
    title: "Gross Earnings",
    description: "Upload recent earnings",
    button: (
      <UploadButton
        mutationResponse="uploadGrossEarnings"
        refetch={refetchQueries}
        uploadMutation={uploadGrossEarningsFile}
        mutationName="uploadGrossEarningsInput"
        ButtonProps={{
          classes: {
            root: classes.cardButtonRoot,
          }
        }}
      />
    ),
    arrowNavigationHref: InternalRoutes.grossEarnings,
  };

  return <CalloutCard {...props} />;
};

export default GrossEarningsCalloutCard;
